import React, { useEffect, useState } from "react";

import { Container, Card, Typography, Grid, Tooltip } from "@material-ui/core";

import Menu from "./menu";
import SessionPanel from "./sessionPanel";
import Footer from "../footer";
import LoadingPage from "../loadingPage";

import { getMenu } from "../../api/menu-apis";
import InfoIcon from "@material-ui/icons/Info";
import LoadingMenuCard from "./loadingMenuCard";
import PizzaCard from "./pizzaCard";

const MenuPage = ({ phone }) => {
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    getMenu().then((res) => {
      setMenu(res.data);
      setLoading(false);
    });
  });

  return (
    <Container disableGutters maxWidth="false">
      <Card
        style={{ backgroundColor: "#4da3fa", padding: "5% 0" }}
        square
        elevation={0}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h1"
            // align="center"
            style={{
              marginRight: "auto",
              fontSize: phone ? null : "10rem",
              // paddingRight: "20px",
            }}
          >
            Menu
          </Typography>

          <br />
          <br />
          <Typography
            variant="h6"
            style={{
              maxWidth: "800px",
              marginLeft: "auto",
              fontSize: phone ? "1rem" : null,
            }}
          >
            Welcome to our catering menu page. Here you can see all the options
            we have available for your event
          </Typography>
          <br />
          <br />

          <div id="#sessionPanelBottom"></div>
          <br />
          <br />
        </Container>
      </Card>
      <div id="#menu"></div>
      <div>
        <Container>
          <Grid container direction="row-reverse">
            <Grid item container direction="column">
              <Container>
                <div id="#essential">
                  <br />
                  <Typography
                    variant="h1"
                    component="h2"
                    style={{ fontSize: phone ? "4rem" : null }}
                  >
                    Essential{" "}
                    <Tooltip
                      title="Here is the menu for the Essential package. If you select the
                    Standard or Premium you can select from our entire menu!"
                    >
                      <InfoIcon style={{ paddingBottom: "50px" }} />
                    </Tooltip>
                  </Typography>

                  <br />
                  <Grid
                    container
                    direction="row"
                    // alignContent="center"
                    alignItems="center"
                    spacing={2}
                  >
                    <LoadingMenuRow fetching={loading} />
                    {menu
                      .filter(
                        (item) =>
                          item.name == "Garlic bread" ||
                          item.name == "Pepperoni" ||
                          item.name == "Margherita" ||
                          item.name == "Marinara" ||
                          item.name == "Veggie",
                      )

                      .map((item) => (
                        <Grid item key={item._id}>
                          <PizzaCard pizza={item} phone={phone} disabled />
                        </Grid>
                      ))}
                  </Grid>
                </div>
                <br />
                <div id="#sides">
                  <br />
                  <Typography
                    variant="h1"
                    component="h2"
                    style={{ fontSize: phone ? "4rem" : null }}
                  >
                    Savory Add-ons
                  </Typography>
                  <br />
                  <Grid
                    container
                    direction="row"
                    // justifyContent="space-evenly"
                    alignItems="center"
                    spacing={2}
                  >
                    <LoadingMenuRow fetching={loading} />
                    {menu
                      .filter(
                        (item) =>
                          item.side &&
                          !item.drink &&
                          item.price >= 5 &&
                          item.price < 10,
                      )

                      .map((item) => (
                        <Grid item key={item._id}>
                          <PizzaCard pizza={item} phone={phone} disabled />
                        </Grid>
                      ))}
                  </Grid>
                </div>
                <br />
                <div id="#mains">
                  <br />
                  <Typography
                    variant="h1"
                    component="h2"
                    style={{ fontSize: phone ? "4rem" : null }}
                  >
                    Pizzas
                  </Typography>
                  <br />
                  <Grid
                    container
                    direction="row"
                    // justifyContent="space-evenly"
                    alignItems="center"
                    spacing={2}
                  >
                    <LoadingMenuRow fetching={loading} />
                    {menu
                      .filter(
                        (item) =>
                          !item.side &&
                          !item.dessert &&
                          item.name !== "The Santa Claus",
                      )

                      .map((item) => (
                        <Grid item key={item._id}>
                          <PizzaCard pizza={item} phone={phone} disabled />
                        </Grid>
                      ))}
                  </Grid>
                </div>{" "}
                <br />
                <div id="#desserts">
                  <br />
                  <Typography
                    variant="h1"
                    component="h2"
                    style={{ fontSize: phone ? "4rem" : null }}
                  >
                    Desserts
                  </Typography>
                  <br />
                  <Grid
                    container
                    direction="row"
                    // justifyContent="space-evenly"
                    alignItems="center"
                    spacing={2}
                  >
                    <LoadingMenuRow fetching={loading} />
                    {menu
                      .filter((item) => item.dessert)

                      .map((item) => (
                        <Grid item key={item._id}>
                          <PizzaCard pizza={item} phone={phone} disabled />
                        </Grid>
                      ))}
                  </Grid>
                </div>
                <br />
              </Container>
            </Grid>
          </Grid>
        </Container>
        <div style={{ padding: "70px" }}></div>
      </div>
      <Footer />
    </Container>
  );
};

const LoadingMenuRow = ({ fetching }) => {
  if (!fetching) return null;
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-evenly"
      alignItems="center"
      spacing={2}
    >
      <Grid item>
        <LoadingMenuCard />
      </Grid>
      <Grid item>
        <LoadingMenuCard />
      </Grid>
      <Grid item>
        <LoadingMenuCard />
      </Grid>
    </Grid>
  );
};

export default MenuPage;
